import HttpClient from "../helpers/HttpClient"
import Product, { ProductDto } from "./Product"
import { isError } from "../helpers/Error"

class ProductService {
    httpClient: HttpClient<Product, ProductDto> = new HttpClient<Product, ProductDto>(Product)

    async getProduct(id: string): Promise<Product> {
        const res = await this.httpClient.get(`/products/${id}`)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as Product
    }

    async create(payload: object): Promise<Product> {
        const res =  await this.httpClient.post("/products", payload)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as Product
    }

    async update(payload: object, productId:string): Promise<Product> {
        const res =  await this.httpClient.patch(`/products/${productId}`, payload)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as Product
    }

    async delete(productId:string): Promise<Product> {
        const res =  await this.httpClient.delete(`/products/${productId}`)
        if (isError(res)) {
            throw new Error(res.message)
        }
        return res as Product
    }
}

const instance = new ProductService()
export default instance


// WEBPACK FOOTER //
// ./src/state/product/ProductService.ts